import {
  Button,
  Div,
  ErrorToast,
  H3,
  H5,
  Img,
  Modal,
  P,
  Radio,
  VDriveOffer,
  displayCentsInDollars,
  lightTheme,
  renderFleetImage,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const VDriveAssignDriver = ({
  modalIsOpen,
  setModalIsOpen,
  noDriverModal,
  setNoDriverModal,
  handleAssignDriver,
}: {
  modalIsOpen: VDriveOffer[] | null;
  setModalIsOpen: Dispatch<SetStateAction<VDriveOffer[] | null>>;
  noDriverModal: boolean;
  setNoDriverModal: Dispatch<SetStateAction<boolean>>;
  handleAssignDriver: (driver: VDriveOffer) => void;
}) => {
  const [selectedDriver, setSelectedDriver] = useState<VDriveOffer | null>(
    null
  );

  const handleSelectDriver = (newItem: VDriveOffer) => {
    setSelectedDriver(newItem);
  };

  useEffect(() => {
    if (modalIsOpen?.[0]) {
      setSelectedDriver(modalIsOpen[0]);
    }
  }, [modalIsOpen]);

  function isDriverSelected(item: VDriveOffer) {
    return selectedDriver?.id === item.id;
  }

  const handleSubmit = () => {
    if (!selectedDriver) return ErrorToast('Please Select Driver');
    handleAssignDriver(selectedDriver);
  };

  return (
    <>
      <Modal
        isOpen={modalIsOpen !== null}
        closeModal={() => setModalIsOpen(null)}
        logo={false}
        vDriveLogo={true}
        zIndex={110}
        footer={
          <>
            <Button
              $m="32px 0 12px 0"
              $w="100%"
              $selected
              onClick={handleSubmit}
            >
              Assign Driver
            </Button>
            <Button
              $w="100%"
              $selected
              $gray
              onClick={() => setModalIsOpen(null)}
            >
              Cancel
            </Button>
          </>
        }
      >
        <H3 $mb="24px">Assign Driver</H3>
        {modalIsOpen !== null &&
          modalIsOpen.map((offer: VDriveOffer, i: number) => (
            <QuoteOfferComponent
              key={i}
              onClick={() => handleSelectDriver(offer)}
              isSelected={isDriverSelected(offer)}
              offer={offer}
            />
          ))}
      </Modal>

      <Modal
        isOpen={noDriverModal}
        closeModal={() => setNoDriverModal(false)}
        logo={false}
        vDriveLogo={true}
        zIndex={110}
      >
        <H3 $mb="12">No Driver</H3>

        <P $mb="0">There are no available drivers at the moment.</P>
        <Button
          $m="32px 0 12px 0"
          $w="100%"
          $selected
          onClick={() => setNoDriverModal(false)}
        >
          Okay
        </Button>
      </Modal>
    </>
  );
};

export const QuoteOfferComponent = ({
  onClick,
  isSelected,
  offer,
}: {
  onClick?: () => void;
  isSelected?: boolean;
  offer: VDriveOffer;
}) => {
  return (
    <Div
      $box
      $p="14px 24px"
      $mb="8"
      $flex
      $alignCenter
      $between
      onClick={onClick}
      $gap="16px"
      $pointer
    >
      <Div $flex $alignCenter $gap="16px">
        <Img
          alt=""
          src={renderFleetImage(offer.provider ?? '')}
          $width="60px"
          $widthSM="50px"
        />
        <div>
          {offer.deliveryMinutes !== -1 && (
            <H5 $left $bold $mb="0" $color={isSelected && lightTheme.primary}>
              Drop Off Time: {offer.deliveryMinutes} min
            </H5>
          )}
          <P $left $mb="0">
            Delivery Fee + Tip:{' '}
            {displayCentsInDollars(offer.price + (offer.tip ?? 0))}
          </P>
          <P $left $mb="0">
            Distance: {offer.distance} miles
          </P>
        </div>
      </Div>

      {onClick && <Radio checked={isSelected ?? false} />}
    </Div>
  );
};
